import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import packageJSON from '../../../../../package.json';
import Button from '../../../../components/Button';
import { HistoryItemWithSkeleton } from '../../../../components/Skeletons/ItemsWithSkeleton';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import RequestService from '../../../../services/RequestService';
import StorageService from '../../../../services/StorageService';
import './BillingHistory.scss';

const { routes } = AppConfig;
const CREDIT_CURRENCY = AppConfig?.creditCurrency ?? 'Credits';
const COUNT_LOAD = 3;
const BILLING_ID = 8;

const BillingHistory = () => {
	const billingBalance = useSelector(state => state.app.billingBalance);

	const navigate = useNavigate();

	const buyBilling = () => {
		navigate({ pathname: routes.buyBillingCurrency });
	};

	const [transactions, setTransactions] = useState([]);
	const [loading, setLoading] = useState(false);

	const GetTransationByCurrency = async () => {
		setLoading(true);

		const res = await RequestService.BillingGetBalanceHistory({
			Page: 0,
			Count: COUNT_LOAD,
		});

		setTransactions(
			res?.History.map(i => ({
				...i,
				TransactuinStatus: 2,
				TransactionType: i.Amount > 0 ? 1 : 2,
				AmountUsd: i.Amount,
				CurrencyId: BILLING_ID,
			}))
		);
		setLoading(false);
	};

	useEffect(() => {
		GetTransationByCurrency();
		StorageService.UpdateBillingBalance();
	}, []);

	return (
		<div className='BillingHistory'>
			<div className='BillingHistory__balance-block FormBlock'>
				<div className='BillingHistory__balance-label'>{t('Your balance')}</div>

				<div className='BillingHistory__balance'>
					{HelperService.FormatFiatWithoutCurrency(billingBalance)} <span>{CREDIT_CURRENCY}</span>
				</div>

				<Button iconBefore='PLUS_CIRCLE_FILL' className='BillingHistory__buy-button' onClick={buyBilling}>
					{t('Buy {currency}', { currency: CREDIT_CURRENCY })}
				</Button>
			</div>

			<div className='HistoryBlock FormBlock'>
				{!transactions.length && !loading && (
					<div className='HistoryBlock__empty'>{t("You don't have transactions")}</div>
				)}
				{(loading || transactions.length > 0) && (
					<>
						<div className='HistoryBlock__header'>
							<div className='HistoryBlock__title'>{t('Recent transactions')}</div>
							<Link to={routes.transactionsHistory} state={{ currencyId: BILLING_ID }}>
								{t('View all')}
							</Link>
						</div>
						<HistoryItemWithSkeleton loading={loading} items={transactions} />
					</>
				)}
			</div>
		</div>
	);
};

export default BillingHistory;
